import React from 'react';
import {useLocation, useLoaderData} from '@remix-run/react';

//components
import Container from 'components/Container';
import BlogListingBreadcrumb from './BlogListingBreadcrumb';
import Blogs from './Blogs';
import BlogListingSidebar from './BlogListingSidebar';
import BlogListingFetch from './BlogListingFetch';

//domains
import type {
  SanityDocBlog,
  SanityBlogTag,
  SanityBlogCategory,
} from 'domains/blog';

interface Props {
  blogs: SanityDocBlog[];
  totalBlogs: number;
  recentBlogs: SanityDocBlog[];
  tags: SanityBlogTag[];
  categories: SanityBlogCategory[];
  blogSettings: {
    blogs_label: string;
    categories_label: string;
    tags_label: string;
    recent_posts_label: string;
  };
  currentTag: SanityBlogTag | null;
  currentCategory: SanityBlogCategory | null;
  heading: string;
  description: string;
  page: number;
  pageCount: number;
}

export default function BlogListing({
  blogs,
  tags,
  categories,
  blogSettings,
  currentTag,
  currentCategory,
  recentBlogs,
  heading,
  description,
  page,
  pageCount,
}: Props) {
  return (
    <div className="pb-20 md:pb-0">
      <Container>
        <BlogListingBreadcrumb
          blogSettings={blogSettings}
          currentTag={currentTag}
          currentCategory={currentCategory}
        />
        <header className="mb-10">
          <h1 className="text-xl font-semibold md:text-section">{heading}</h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-600">
            {description}
          </p>
        </header>
        <section className="section--blogs">
          <div className="grid gap-8 md:grid-cols-3">
            <Blogs blogs={blogs} />
            <BlogListingSidebar
              tags={tags}
              categories={categories}
              blogSettings={blogSettings}
              recentBlogs={recentBlogs}
            />
          </div>
          <BlogListingFetch page={page} pageCount={pageCount} />
        </section>
      </Container>
    </div>
  );
}
